export default "__VITE_ASSET__BTOO1nwm__"